import React, { useEffect, useState } from "react";
// import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import TopTabs from "../../components/TopTabs";
import { Outlet, useParams } from "react-router-dom";
import { HOSTNAME } from "../../config/constants";
import { collection, doc, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../config/firebaseConfig";
import { setfilterData, setsectionData } from "../../redux/actions/menu";

const AddItems = () => {
  const { sectionData, filterData } = useSelector((state) => state.menu);

  const dispatch = useDispatch();

  const { outlet, table } = useParams();

  const data = [
    {
      name: "Add Food",
      url: table ? `/manage/${outlet}/${table}/add/food` : `/manage/${outlet}/add/food`,
    },
    {
      name: "Add Filter",
      url: table ? `/manage/${outlet}/${table}/add/filter` : `/manage/${outlet}/add/filter`,
    },

    {
      name: "Add Section",
      url: table ? `/manage/${outlet}/${table}/add/section` : `/manage/${outlet}/add/section`,
    },
  ];

  return (
    <div className="add-items">
      <TopTabs data={data} size="sm" />
    </div>
  );
};

export default AddItems;
